module.exports = __webpack_public_path__ + "static/media/book8.c2da7f04.jpg";